import { useEffect, useState } from "react";
import CreateButton from "../../components/CreateButton/createButton";
import "./Pin.css";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { designService } from "../../services/designService";
import STATIC_ROUTES from "../../misc/Static_routes";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ImageLoading from "../../components/misc/ImageLoading/ImageLoading";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTranslation } from "react-i18next";
import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import NotFound from "../NotFound/NotFound";
import BreadcrumbsNavigation from "../../components/Breadcrumbs/BreadcrumbsNavigation";
import SelectFiltration from "../../components/SelectFiltration/SelectFiltration";
import { filterByDesignsValues, filterByValues } from "../../utils/constants";
import { calculateGridElements } from "../../utils/helpers";
import DesignCards from "../../components/DesignCards/DesignCards";
import CircleLoading from "../../components/misc/CircleLoading/CircleLoading";

const Pin = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const params = useParams();
  const [offsetParam, setOffsetParam] = useState(0);
  const [cityName, setCityName] = useState("");
  const [designs, setDesigns] = useState([]);
  const [page, setPage] = useState(1);
  const [startIndexItem, setStartIndexItem] = useState(0);
  const [sortBy, setSortBy] = useState("date");
  const [sortOrder, setSortOrder] = useState("mostRecent");
  const [loadIndex, setLoadIndex] = useState(1);
  const pageSize = calculateGridElements();
  const numbers = Array.from({ length: pageSize }, (_, index) => index);
  const {
    isLoading,
    data: designsResult,
    error,
    isPlaceholderData,
    isFetching
  } = useQuery({
    queryKey: ["pinDesigns", page],
    queryFn: () =>
      designService.getDesignByPinIdInRange(
        `/api/pin/${params.pinID}/designs/${offsetParam}/${pageSize}`
      )
  });

  const filterBy = (value) => {
    setSortOrder(value);
  };

  useEffect(() => {
    if (!isPlaceholderData && designsResult?.data) {
      queryClient.prefetchQuery({
        queryKey: ["pinDesigns", page],
        queryFn: () =>
          designService.getDesignByPinIdInRange(
            `/api/pin/${params.pinID}/designs/${offsetParam}/${pageSize}`
          ),
      });
    }
  }, []);

  const lastPage = Math.ceil(designsResult?.data?.designsCount / pageSize);

  const setActiveClass = (e) => {
    const removeClass = document.querySelectorAll(".filter");
    removeClass.forEach((element) => {
      element.classList.remove("active");
    });
    e.currentTarget.classList.add("active");
  };

  const sortByDate = (e) => {
    setActiveClass(e);
    setDesigns([
      designsResult?.data?.data?.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      ),
    ]);
    setSortBy("date");
  };

  const sortByLikes = (e) => {
    setActiveClass(e);
    designsResult?.data?.data?.sort((a, b) => b.likes.length - a.likes.length);
    setSortBy("likes");
  };

  const onClickDesign = (design) => {
    navigate(`/pin/${design.pin_id}/design/${design.id}`);
  };

  const handlePageChange = (event, pg) => {
    setOffsetParam((pg - 1) * pageSize);
    setPage(pg);
  };

  return (
    <>
      {!designsResult && !isLoading && <NotFound></NotFound>}
      {isLoading || isFetching ? (
          <p className="loading">
            <CircleLoading />
        </p>
      ) : (
        <div className="pin-page">
          <div className="pin_page_heading">
            <img
              className="heading_page_img"
              src={designsResult?.data?.pinImage}
              alt="Location image"
            />
            <div className="heading_title_wrapper">
              <div className="titles_wrapper_main">
                <div className="title_small">{t("welcomeTo")}</div>
                <div className="title_large">
                  <span className="title_word_background_line_wrapper">
                    {" "}
                    <span className="title_word_background_line"></span>
                    {designsResult?.data?.pinName + ","}
                  </span>
                  {" " + designsResult?.data?.cityName}
                </div>
              </div>
              <div className="create_design_btn_wrapper">
                <button
                  onClick={() => navigate(`/pin/${params.pinID}/create-design`)}
                  className="btn_rounded_border_animation create_design_btn"
                >
                  <span className="btn_rounded_border_animation_text">{t("makeDesign")}</span>
                </button>
              </div>
            </div>
          </div>
          <div className="page_content">
            <div className="curr_location_title_wrapper">
              <p className="curr_location_title">DISCOVER INSPIRATIONS</p>
              <p className="curr_location_subtitle">
                Explore proposals, create yours!
              </p>
            </div>
            <div className="breadcrumbs_filter">
              <div className="breadcrumbs_container">
                <BreadcrumbsNavigation
                  locations={[
                    { link: STATIC_ROUTES.home, name: "Cotown Map" },
                    { link: `/${params.city}`, name: params.city },
                    {
                      link: `/${params.city}/${params.pinID}`,
                      name: designsResult?.data?.pinName,
                    },
                  ]}
                ></BreadcrumbsNavigation>
              </div>
              <div className="select_filter_home">
                <SelectFiltration
                  value={sortOrder}
                  values={filterByDesignsValues}
                  filterBy={(e) => filterBy(e)}
                ></SelectFiltration>
              </div>
            </div>
            <div className="designs">
              <DesignCards
                designData={designsResult?.data}
                sortOrder={sortOrder}
                loadIndex={loadIndex}
                pageSize={pageSize}
              ></DesignCards>
            </div>
                  <Stack
                    spacing={2}
                    sx={{
                      flexWrap: "wrap",
                      alignContent: "center",
                      marginBottom: "40px",
                      display: designsResult?.data?.totalDesignsCount > pageSize ? 'flex' : 'none'
                    }}
                  >
                    <Pagination
                      count={Math.ceil(
                        designsResult?.data?.totalDesignsCount / pageSize
                      )}
                      shape="rounded"
                      page={page}
                      onChange={handlePageChange}
                    />
                  </Stack>
    
          </div>
        </div>
      )}
      </>
  );
};

export default Pin;
